import { IconButton, Flex, Tooltip } from "@radix-ui/themes";
import { ArrowUp, ArrowDown, ChevronsUp } from "lucide-react";

interface Props {
  index: number;
  total: number;
  /** Given the destination index, sends the whole new ordering. */
  onMove: (to: number) => void;
}

// Buttons rather than drag-and-drop, deliberately. A gallery's working order is
// the order it was uploaded in; what actually gets rearranged by hand is the
// first few frames, which is what "to front" is for. Dragging one thumbnail
// across a wrapping grid of two hundred is worse than it sounds, and this needs
// no dependency and works under a thumb.
export default function ReorderControls({ index, total, onMove }: Props) {
  const isFirst = index === 0;
  const isLast = index === total - 1;

  return (
    <Flex gap="1">
      <Tooltip content="Move to front">
        <IconButton
          size="1"
          variant="soft"
          color="gray"
          disabled={isFirst}
          onClick={() => onMove(0)}
          aria-label="Move to front"
        >
          <ChevronsUp size={13} />
        </IconButton>
      </Tooltip>
      <Tooltip content="Move earlier">
        <IconButton
          size="1"
          variant="soft"
          color="gray"
          disabled={isFirst}
          onClick={() => onMove(index - 1)}
          aria-label="Move earlier"
        >
          <ArrowUp size={13} />
        </IconButton>
      </Tooltip>
      <Tooltip content="Move later">
        <IconButton
          size="1"
          variant="soft"
          color="gray"
          disabled={isLast}
          onClick={() => onMove(index + 1)}
          aria-label="Move later"
        >
          <ArrowDown size={13} />
        </IconButton>
      </Tooltip>
    </Flex>
  );
}
